import React from 'react'
import { List, Avatar, Form, Input, Button } from 'antd'
import { UserOutlined, SendOutlined } from '@ant-design/icons'
import type { Dispute } from '../types/dispute.types'
import { mockMessages } from '../data/mockDisputes'

interface DisputeConversationProps {
    dispute: Dispute
    onSendMessage: (values: any) => void
}

export const DisputeConversation: React.FC<DisputeConversationProps> = ({ dispute, onSendMessage }) => {
    const [form] = Form.useForm()

    const handleFinish = (values: any) => {
        onSendMessage(values)
        form.resetFields()
    }

    return (
        <div>
            <h3>Conversation</h3>
            <List
                dataSource={mockMessages}
                renderItem={(msg) => (
                    <List.Item>
                        <List.Item.Meta
                            avatar={
                                <Avatar icon={<UserOutlined />} style={{
                                    backgroundColor: msg.role === 'admin' ? '#7c3aed' : msg.role === 'merchant' ? '#3b82f6' : '#10b981'
                                }} />
                            }
                            title={<strong>{msg.sender}</strong>}
                            description={
                                <div>
                                    <p style={{ marginBottom: 4 }}>{msg.message}</p>
                                    <span style={{ fontSize: 12, color: '#999' }}>{msg.timestamp}</span>
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />

            {dispute.status !== 'closed' && dispute.status !== 'resolved' && (
                <Form form={form} onFinish={handleFinish}>
                    <Form.Item name="message" rules={[{ required: true, message: 'Please enter a message' }]}>
                        <Input.TextArea rows={3} placeholder="Type your message..." />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" icon={<SendOutlined />}>
                            Send Message
                        </Button>
                    </Form.Item>
                </Form>
            )}
        </div>
    )
}
